import { styled } from '@mui/material/styles';

interface StyledImageAvatarProps {
  width?: string;
  height?: string;
}

const StyledImageAvatar = styled('img')<StyledImageAvatarProps>`
  width: ${({ width }) => width || '50px'};
  height: ${({ height }) => height || '50px'};
  border-radius: 8px;
`;

export default StyledImageAvatar;
